import { Injectable, signal } from '@angular/core';

@Injectable()
export class RulesService {
  selectionActive = signal<boolean>(false);

  clickedWidget = signal<string | undefined>(undefined);
}
